import type { FaireProductEntity } from "../../entity_types/product";

export const p_5sa2j862jx: FaireProductEntity = {
  token: "p_5sa2j862jx",
  type: "product",
  name: "PopQorn - Fine Popping Kernels",
  brandToken: "b_7099d1ce",
  brandName: "BjornQorn",
  imageUrl:
    "https://cdn.faire.com/fastly/d1026090dd38190fdd6d733b273c88d7483a03cc37e6ffeabda2ea86f70ac84b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53645c8edc901236423876a2f1d95affb53458ad11e4a818220a37cc6f04ac6b.jpeg",
    "https://cdn.faire.com/fastly/5badfc03c258855aa3242be612a1dfdbc7df9958ad98eea2ed9c95677942b6ba.jpeg",
  ],
  priceDollars: 5,
  description:
    '2lbs yellow butterfly popcorn kernels / 9 per box. The same kernels we grow and pop!\n\nEach box is 7"x4"x3"\n\nAt last we can now offer you our wonderful BjornQorn fine popcorn kernels to make at home for after school snacks or late night movies!  The kernels are Non-Gmo Project Verified and grown on Bjorn\'s family farm in Minnesota or one of our partner farms in New York\'s Hudson Valley.  \n\nYou can know which farm it came from by looking at the lot number on the bottom of the box. The first two letters are the farm the the second two are the harvest year. \n\n"MN" = Bjorn\'s family farm in Minnesota\n\n"KF" = Kelder\'s Farm in New York\n\n"FH" = Hudson Valley Farm Hub in New York\n\nCurrently we are boxing our MN20 harvest which was maybe the best harvest we\'ve ever had, but we\'re really excited to move into Kelder\'s and Hudson Valley Farm Hub\'s harvests. There are differences farm to farm in terms of size, color and texture even starting from the same seed. \n\nCrunchy, Crispy butterfly kernels\n',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:23.711Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
